module.exports = __webpack_public_path__ + "static/media/banner2.b422223e.png";